import { ConfigurationRepositoryConfigurationAdminService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationAdminService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { allConciseBranchesKeyPrefix } from '../keys/configuration'

type ForceDeleteBranchInputArguments = {
  branchName: string
  server: ConfigurableServer
}

export const useForceDeleteConciseBranch = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      branchName,
      server,
    }: ForceDeleteBranchInputArguments) => {
      await ConfigurationRepositoryConfigurationAdminService.configurationAdminServiceDeleteForceDeleteBranch(
        {
          branchName,
          componentName: server.toLocaleLowerCase(),
        },
      )
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [allConciseBranchesKeyPrefix],
      }),
  })
}
